import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import { IVariant } from "shared/hubrise/models"

interface UseVariants {
  selectedVariant: IVariant | null
}

const useVariants = (): UseVariants => {
  const { catalog } = useEditor()
  const { variantRef } = useCatalogNavigation()

  const selectedVariant = catalog.data.variants.find((variant) => variant.ref === variantRef) ?? null

  return { selectedVariant }
}

export default useVariants
